export default "__VITE_PUBLIC_ASSET__6edb6b56__"